import React from 'react';
import moment from 'moment';
import { DateRangePicker } from 'react-dates';

const LocaleDateRangePicker = ({
  locale = 'en-US', // "en-AU" | "es-AR" | etc.
  ...restProps
}) => {
  React.useEffect(() => {
    if (!locale) {
      return;
    }

    const mLocaleKey = locale.toLowerCase();

    import(`moment/locale/${mLocaleKey}`)
      .then(() => {
        moment.locale(mLocaleKey);
      })
      .catch(() => {
        const baseLang = mLocaleKey.split('-')[0];
        import(`moment/locale/${baseLang}`).finally(() => {
          moment.locale(baseLang);
        });
      });
  }, [locale]);

  return <DateRangePicker {...restProps} />;
};

export default LocaleDateRangePicker;
